import axios from "axios";

import links from "../utils/externalLinks";

const _commomExtract = (data) => {
  const { market_data } = data;
  const { usd: currentPriceUsd } = market_data.current_price;
  const { usd: marketCapUsd } = market_data.market_cap;
  const { circulating_supply: circulatingSupply } = market_data;
  const { usd: totalVolumeUsd } = market_data.total_volume;

  return {
    currentPriceUsd,
    marketCapUsd,
    circulatingSupply,
    totalVolumeUsd,
  };
};

// eslint-disable-next-line
export const getDagInfos = async () => {
  const { data } = await axios.get(links.COIN_GECKO_DAG);
  return _commomExtract(data);
};
// eslint-disable-next-line
export const getLtxInfos = async () => {
  const { data } = await axios.get(links.COIN_GECKO_LTX);
  return _commomExtract(data);
};
